import axios, { AxiosResponse } from "axios";

import { KEYURL } from "../Shared/constant";
import { IToken } from "./dtos";

// import {

// } from "./dtos";

const axiosInterceptor = axios.create({
  baseURL: KEYURL,
});

axiosInterceptor.interceptors.request.use(
  (req) => {
    req.headers.Authorization = `Bearer ${sessionStorage.getItem("token")}`;
    return req;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInterceptor.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    // const status = err.response ? err.response.status : null;
    // if (status === 401) {
    //   {
    //     if (sessionStorage.getItem("token")) {
    //       sessionStorage.removeItem("token");
    //     }
    //     window.location.reload();
    //   }
    // }
    return Promise.reject(err);
  }
);

export const loginAPICall = (requestBody: any) => {
  let bodyFormData = new FormData();
  Object.keys(requestBody).map((key) => {
    bodyFormData.append(key, requestBody[key]);
  });
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/token`, bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

export const getAPIKeyAPICall = () => {
  let requestBody = {
    userID: sessionStorage.getItem("userID"),
  };
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .put(`/getAPIKey`, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

export const userDetailsAPICall = () => {
  let requestBody = {
    uid: sessionStorage.getItem("userID"),
    jKey: sessionStorage.getItem("tokenType"),
  };
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`userDetails`, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const LogoutAPICall = () => {
  let requestBody = {
    jKey: sessionStorage.getItem("tokenType"),
  };
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/logout`, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const refreshAPIKeyAPICall = () => {
  let requestBody = {
    userID: sessionStorage.getItem("userID"),
    sessionID: sessionStorage.getItem("token"),
  };
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`updateAPIKey`, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

export const firstTimeUserAPICall = () => {
  let requestBody = {
    userID: sessionStorage.getItem("userID"),
  };
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/firstlogin`, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
